const LOGIN_EVENTS = {
  VIEWED_CREATE_PASSWORD: 'Viewed Create Password Page',
  CREATED_PASSWORD: 'Password Created',
  RETURNED_TO_SIGNUP: 'Returned To Sign Up Page',
  VIEWED_REQUEST_EMAIL_LINK: 'Viewed Request Email Link Page',
  REQUESTED_EMAIL_LINK: 'Email Link Requested',
  VIEWED_LOGIN_PAGE: 'Viewed Login Page',
  VIEWED_LOGIN_WITH_TOKEN_PAGE: 'Viewed Login With Token Page',
  LOGGED_IN: 'Logged In',
  LOGGED_OUT: 'Logged Out',
} as const
const ONBOARDING_EVENTS = {
  VIEWED_ONBOARDING_CARRIER: 'Viewed Onboarding Carrier Page',
  VIEWED_ONBOARDING_DRIVERS: 'Viewed Onboarding Drivers Page',
  SKIPPED_ONBOARDING_DRIVERS: 'Skipped Onboarding Drivers Page',
  COMPLETED_ONBOARDING_DRIVERS: 'Completed Onboarding Drivers Page',
  VIEWED_SAMPLE_LOAD: 'Viewed Sample Load',
  VIEWED_ONBOARDING_WELCOME_MODAL: 'Viewed Onboarding Welcome Modal',
  SKIPPED_ONBOARDING_WELCOME_MODAL: 'Skipped Welcome Modal',
  ADD_LOAD_AFTER_ONBOARDING_WELCOME_MODAL: 'Added Load After Welcome Modal',
  VIEWED_FMS_ONBOARDING_EMAIL: 'Viewed FMS Onboarding: Email',
  SUBMITTED_FMS_ONBOARDING_EMAIL_INVALID_FORM: 'Submitted Email Form: Invalid form',
  SUBMITTED_FMS_ONBOARDING_EMAIL: 'Submitted FMS Onboarding: Email Form',
  VIEWED_FMS_ONBOARDING_CHECK_EMAIL: 'Viewed FMS Onboarding: Check your Email',
  VIEWED_FMS_ONBOARDING_RETURNING_USER: 'Viewed FMS Onboarding: Returning User Form',
  SUBMITTED_FMS_ONBOARDING_RETURNING_USER_INVALID_FORM:
    'Submitted Returning User Form: Invalid form',
  VIEWED_FMS_ONBOARDING_NEW_USER: 'Viewed FMS Onboarding: New User Form',
  SUBMITTED_FMS_ONBOARDING_NEW_USER_INVALID_FORM: 'Submitted New User Form: Invalid form',
  VIEWED_FMS_ONBOARDING_SIGNUP_INTENT: 'Viewed FMS Onboarding: Signup Intent Options',
  VIEWED_FMS_ONBOARDING_CARRIERS: 'Viewed FMS Onboarding: Select Carriers',
  VIEWED_FMS_ONBOARDING_CARRIER_APPROVAL: 'Viewed FMS Onboarding: Carrier needs approval',
  COMPLETED_FMS_ONBOARDING: 'Completed FMS Onboarding',
  ONBOARDING_VIEWED_SIGNUP_PAGE: 'Viewed Signup Page',
  ONBOARDING_SUCCESSFULLY_SUBMITTED_FORM_ON_SIGNUP_PAGE:
    'Successfully Submitted Form on Signup Page',
  ONBOARDING_FAILED_TO_SUBMIT_FORM_ON_SIGNUP_PAGE: 'Failed to Submit Form on Signup Page',
  ONBOARDING_FORM_API_ERROR_SIGNUP_PAGE: 'Encountered Form API Error on Signup Page',
  ONBOARDING_VIEWED_CHECK_YOUR_EMAIL_PAGE: 'Viewed Check Your Email Page',
  ONBOARDING_VIEWED_CREATE_ACCOUNT_PAGE: 'Viewed Create Account Page',
  ONBOARDING_SUCCESSFULLY_SUBMITTED_FORM_ON_CREATE_ACCOUNT_PAGE:
    'Successfully Submitted Form on Create Account Page',
  ONBOARDING_FAILED_TO_SUBMIT_FORM_ON_CREATE_ACCOUNT_PAGE:
    'Failed to Submit Form on Create Account Page',
  ONBOARDING_FORM_API_ERROR_NEW_USER_PAGE: 'Encountered Form API Error on Create Account Page',
  ONBOARDING_VIEWED_CONFIRM_YOUR_ACCOUNT_INFO_PAGE: 'Viewed Confirm Your Account Info Page',
  ONBOARDING_SUCCESSFULLY_SUBMITTED_FORM_ON_CONFIRM_YOUR_ACCOUNT_INFO_PAGE:
    'Successfully Submitted Form on Confirm Your Account Info Page',
  ONBOARDING_FAILED_TO_SUBMIT_FORM_ON_CONFIRM_YOUR_ACCOUNT_INFO_PAGE:
    'Failed to Submit Form on Confirm Your Account Info Page',
  ONBOARDING_FORM_API_ERROR_RETURNING_USER_PAGE:
    'Encountered Form API Error on Confirm Your Account Info Page',
  ONBOARDING_AUTH_FAILED: 'Confirm Your Account page: Token Authentication Failed',
  ONBOARDING_VIEWED_SIGNUP_INTENT_PAGE: 'Viewed Signup Intent Page',
  ONBOARDING_SUCCESSFULLY_SUBMITTED_FORM_ON_SIGNUP_INTENT_PAGE:
    'Successfully Submitted Form on Signup Intent Page',
  ONBOARDING_SELECT_OPTION: 'User selected Intent Option',
  ONBOARDING_FAILED_TO_SUBMIT_FORM_ON_SIGNUP_INTENT_PAGE:
    'Failed to Submit Form on Signup Intent Page',
  ONBOARDING_VIEWED_ADD_CARRIERS_AT_SIGNUP_PAGE: 'Viewed Add Carriers at Signup Page',
  ONBOARDING_SUCCESSFULLY_ADDED_CARRIER_ON_ADD_CARRIERS_AT_SIGNUP_PAGE:
    'Successfully Added Carrier on Add Carriers at Signup Page',
  ONBOARDING_FAILED_TO_ADD_CARRIER_ON_ADD_CARRIERS_AT_SIGNUP_PAGE:
    'Failed to Add Carrier on Add Carriers at Signup Page',
  ONBOARDING_USER_REQUESTED_TO_JOIN_CARRIER_FROM_ADD_CARRIERS_AT_SIGNUP_PAGE:
    'User Requested to Join Carrier from Add Carriers at Signup Page',
} as const
const FLEET_EVENTS = {
  VIEWED_FLEET_PAGE: 'Viewed Fleet Page',
  OPEN_ADD_LOAD_MODAL_FV: 'Opened Add Load Modal (fleet view)',
  OPEN_ADD_LOAD_MODAL_FVDR: 'Opened Add Load Modal (fleet view driver row)',
} as const
const LOAD_LIST_EVENTS = {
  VIEWED_LOAD_LIST: 'Viewed Load List',
  OPEN_ADD_LOAD_MODAL_LL: 'Opened Add Load Modal (load list)',
  OPEN_EDIT_LOAD_MODAL: 'Opened Edit Load Modal',
  OPEN_LOAD_DETAILS_PAGE: 'Opened Load Details Page',
} as const
const LOAD_EVENTS = {
  CREATED_LOAD: 'Created Load',
  EDITED_LOAD: 'Edited Load',
  CHANGED_LOAD_STATUS: 'Changed Load Status',
  UPDATED_ASSIGNMENT_DETAILS: 'Updated Load Assignment Details',
  ERROR_UPDATING_ASSIGNMENT_DETAILS: 'Error Updating Assignment Details',
  DISPATCHER_IN_OUT_FORM_SUBMIT: 'Submitted Checkin/Checkout Form via Status Update Flow',
  DISPATCHER_IN_OUT_VALUES_CHANGED: 'Changed Checkin/Checkout Values via Status Update Flow',
  DISPATCHER_PICKUP_ETA_FORM_SUBMIT: 'Submitted Pickup ETA Form via Status Update Flow',
  VIEWED_SHARE_LOAD_MODAL: 'Viewed Share Load Modal',
  SHARED_LOAD_WITH_DRIVER: 'Shared Load with Driver',
  CLICKED_TRANSFIX_MP_LINK: 'Clicked Transfix Marketplace Link',
  CLICKED_BILL_PDF_FROM_LOAD_DETAILS: 'Clicked Bill PDF Link from Load Details',
  CLICKED_TRIUMPHPAY_LINK_FROM_LOAD_DETAILS: 'Clicked TriumphPay link from Load Details',
} as const
const CARRIER_PROFILE_EVENTS = {
  VIEWED_CARRIER_PROFILE: 'Viewed Carrier Profile',
  ADDED_CARRIER: 'Carrier Added',
  REMOVED_CARRIER: 'Carrier Removed',
  UPDATED_CARRIER_PREFERENCE: 'Updated Carrier Preference',
  // Fleet Info Card
  OPENED_FREIGHT_CAPABILITIES: 'Opened Freight Capabilities Modal',
  UPDATED_FREIGHT_CAPABILITIES: 'Updated Freight Capabilities',
  OPENED_EQUIPMENT_TYPES: 'Opened Equipment Types Modal',
  UPDATED_EQUIPMENT_TYPES: 'Updated Equipment Types',
  OPENED_ENDORSEMENTS: 'Opened Endorsements Modal',
  UPDATED_ENDORSEMENTS: 'Updated Endorsements',
  // Load Preferences Card
  OPENED_LOAD_TYPES: 'Opened Load Types Modal',
  UPDATED_LOAD_TYPES: 'Updated Load Type Preferences',
  OPENED_RATE_TYPES: 'Opened Rate Types Modal',
  UPDATED_RATE_TYPES: 'Updated Rate Type Preferences',
  OPENED_DEDICATED_LANE_PREFERENCE: 'Opened Dedicated Lane Preference Modal',
  UPDATED_DEDICATED_LANE_PREFERENCE: 'Updated Dedicated Lane Preference',
  OPENED_HEAVY_LOADS_PREFERENCE: 'Opened Heavy Loads Preference Modal',
  UPDATED_HEAVY_LOADS_PREFERENCE: 'Updated Heavy Loads Preference',
  OPENED_EXCLUDED_COMMODITIES: 'Opened Excluded Commodities Modal',
  UPDATED_EXCLUDED_COMMODITIES: 'Updated Excluded Commodities Preference',
  // Certifications Card
  ADDED_CERTIFICATION: 'Added Certification',
  UPDATED_CERTIFICATION: 'Updated Certification',
  DELETED_CERTIFICATION: 'Deleted Certification',
} as const
const SETTINGS_EVENTS = {
  VIEWED_GENERAL_SETTINGS: 'Viewed General Settings',
  SAVED_GENERAL_SETTINGS: 'Saved General Settings',
  VIEWED_PROFILE_SETTINGS: 'Viewed Profile Settings',
  SAVED_PROFILE_SETTINGS: 'Saved Profile Settings',
  VIEWED_ORGANIZATION_SETTINGS: 'Viewed Organization Settings',
  SAVED_ORGANIZATION_SETTINGS: 'Saved Organization Settings',
  DELETE_USER_ACCOUNT_SETTINGS: 'Delete User Account Settings',
} as const
const SUPPORT_MODAL_EVENTS = {
  VIEWED_SUPPORT_MODAL: 'Viewed Support Modal',
  CLICKED_SUPPORT_EMAIL: 'Clicked Support Email',
  CLICKED_FAQ_LINK: 'Clicked FAQ Link',
  CLICKED_STATUS_PAGE_LINK: 'Clicked Status page Link',
} as const
const MARKETPLACE_LOAD_EVENTS = {
  VIEWED_EXTERNAL_LOAD_SYNC_MODAL: 'Viewed External Load Sync Modal',
  EXTERNAL_LOAD_IMPORT_SUCCESS: 'External Load Import Succeeded',
  EXTERNAL_LOAD_IMPORT_FAILURE: 'External Load Import Failed',
  VIEWED_LOAD_NOT_AVAILABLE: 'Viewed Load Not Available',
} as const
const MANAGE_DRIVER_EVENTS = {
  VIEWED_MANAGE_DRIVERS_PAGE: 'Viewed Manage Drivers Page',
  ADD_DRIVER_MANAGE_DRIVERS: 'Added Driver from Manage Drivers Page',
  EDIT_DRIVER_MANAGE_DRIVERS: 'Edited Driver from Manage Drivers Page',
  DEACTIVATE_DRIVER_MANAGE_DRIVERS: 'Deactivated Driver from Manage Drivers Page',
} as const
const BULK_UPLOAD_EVENTS = {
  CLICK_DRIVERS_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Drivers Link',
  CLICK_CUSTOMERS_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Customers Link',
  CLICK_TRAILERS_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Trailers Link',
  CLICK_TRUCKS_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Trucks Link',
  CLICK_FACILITIES_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Facilities Link',
  CLICK_RATECONS_BULK_UPLOAD_LINK: 'Clicked Bulk Upload Rate Confirmations Link',
} as const
const BOOK_LOAD_EVENTS = {
  CLICKED_BOOK_LOADS_LINK: 'Clicked Book Loads item in Side Nav',
  VISITED_BOOK_LOADS: 'Visited Book Loads Page',
  SEARCHED_BOOK_LOADS: 'Searched Loads on Book Loads Page',
  CLICKED_BOOK_NOW_CTA: 'Clicked Book Now Button on Book Loads Page',
  CLICKED_SUBMIT_BID_CTA: 'Clicked Submit Bid Button on Book Loads Page',
  CLICKED_CONTACT_BROKER_CTA: 'Clicked Contact Broker Button on Book Loads Page',
  VIEWED_SEARCH_RESULTS_ON_BOOK_LOADS_PAGE: 'Viewed Search Results on Book Loads Page',
  VIEWED_BOOKABLE_LOAD_MODAL: 'Viewed Bookable Load Modal',
  VIEWED_BOOKABLE_LOAD_PAGE: 'Viewed Bookable Load Page',
  VIEWED_UNAVAILABLE_LOAD: 'Viewed Unavailable Load',
  CLICKED_BID_ON_BOOKABLE_LOAD: 'Clicked Bid On Bookable Load',
  SUCCESSFULLY_SUBMITTED_BID_ON_BOOKABLE_LOAD: 'Successfully Submitted Bid On Bookable Load',
  BID_ADD_FAILURE: 'Failed to Submit Bid on Bookable Load',
  BID_EDIT_FAILURE: 'Failed to Edit Bid on Bookable Load',
  DELETED_EXISTING_BID_ON_BOOKABLE_LOAD: 'Deleted Existing Bid On Bookable Load',
  ACCEPTED_COUNTER_OFFER_ON_BOOKABLE_LOAD: 'Accepted Counter Offer On Bookable Load',
  CLICKED_POST_MY_TRUCKS: 'Clicked Posted My Trucks in Book Loads Page',
  CLICKED_MY_BIDS: 'Clicked My Bids in Book Load Page',
  CLICKED_VIEW_ALL_RUN_IT_AGAIN_LINK: 'Clicked View All Run It Again link in Book Loads Page',
  CLICKED_VIEW_ALL_LANES_LINK: 'Clicked View All link in Book Loads Page',
  CLICKED_VIEW_MORE_LIKE_THIS: 'Clicked View More Like This Search Button in Book Loads Page',
  VIEWED_RUN_IT_AGAIN_LOAD: 'Viewed Run It Again Load in Book Loads Page',
  CLICKED_MY_LANE_ALERT_TILE: 'Clicked My Lane Alert Tile in Book Loads Page',
  USER_MOTOR_CARRIERS_EMPTY: 'User Motor Carriers empty',
  DOES_NOT_HAVE_PERMISSION_TO_BOOK_MODAL_OPENED: 'Does not have permission to book modal displayed',
  DOES_NOT_HAVE_PERMISSION_TO_BID_MODAL_OPENED: 'Does not have permission to bid modal displayed',
} as const
const BIDS_PAGE_EVENTS = {
  ACCEPTED_CLICKED_BOOK_NOW: 'Clicked book now in the accepted bids section',
  DECLINED_CLICKED_BID_AGAIN: 'Clicked bid again in the declined bids section',
  PENDING_CLICKED_EDIT_BID: 'Clicked edit button in the pending bids section',
  PENDING_CLICKED_ACCEPT_COUNTER_OFFER:
    'Clicked accept counter offer button in the pending bids section',
  CLICKED_MY_BIDS_BUTTON: 'Clicked my bids button to enter the Bids page',
} as const
const BID_ACCEPTED_MODAL_EVENTS = {
  VIEWED_BID_ACCEPTED_MODAL: 'Viewed Bid Accepted Modal',
  CLICKED_BOOK_NOW_MODAL: 'Clicked book now in the bid accepted modal',
} as const
const BID_COUNTERED_MODAL_EVENTS = {
  VIEWED_COUNTER_OFFER_ON_LOAD_MODAL: 'Viewed Realtime Counteroffer on Load Details Modal',
  ACCEPTED_COUNTER_OFFER_ON_LOAD_MODAL: 'Accepted Counter Offer on Load Details Modal',
} as const
const RATE_CON_EVENTS = {
  VIEWED_RATE_CONFIRMATION: 'Viewed Rate Con',
  CANCELED_RATE_CONFIRMATION: 'Canceled Signing Rate Con',
  BID_RATE_CONFIRMATION: 'Bid From Rate Con ',
  SUBMIT_RATE_CON_FORM: 'Success Submitting Rate Con Form',
  FAILED_SUBMIT_RATE_CON_FORM: 'Failed to Submit Rate Con Form',
  SUBMIT_RATE_CON_FOR_COUNTERBID: 'Submitted a Rate Con for a CounterBid',
  RATE_CONFIRMATION_ERROR_STATE: 'Shown Rate Con error state',
  ERROR_USER_DOES_NOT_HAVE_PERMISSION: 'Error: User does not have permission to book',
} as const
const DRIVER_LED_STATUS_EVENTS = {
  DRIVER_LED_STATUS_WELCOME_MODAL_VIEWED: 'Viewed “Driver Led Status Updates” Welcome Modal',
  DRIVER_LED_STATUS_DRIVERS_TRAILER_NUMBER_SUBMIT:
    'Submitted Trailer Number on Driver Led Status Updates',
  DRIVER_LED_STATUS_DRIVER_CELL_CONFIRMED:
    'Confirmed Driver Cell on “Driver Led Status Updates” Welcome Modal',
  DRIVER_LED_STATUS_LOADS_MODAL_UPDATES_ON:
    'Clicked to turn on Driver Led Status Updates from Load Modal',
  DRIVER_LED_STATUS_DRIVERS_PAGE_UPDATES_ON:
    'Clicked to turn on Driver Led Status Updated from Manage Drivers',
  DRIVER_LED_STATUS_DRIVERS_STATUS_UPDATED:
    'Clicked Status Update button from Driver’s Load Details Page',
  DRIVER_LED_STATUS_DRIVERS_IN_OUT_FORM_VIEWED: 'Viewed Check In or Check Out Form',
  DRIVER_LED_STATUS_DRIVERS_IN_OUT_FORM_SUBMIT: 'Submitted Check In or Check Out Form',
  DRIVER_OPT_IN_MODAL_OPENED: 'Opened Driver Opt In Modal',
  DRIVER_OPT_IN_MODAL_DISMISSED: 'Dismissed Driver Opt In Modal',
  SELECTED_LOAD_ONE_TIME_UPDATE: 'Selected Load One Time Update',
  SELECTED_LOAD_UPDATE_THROUGHOUT: 'Selected Load Update Throughout',
} as const
const POD_UPLOAD_EVENTS = {
  POD_UPLOADED_DISPATCHER_VIEW: 'Uploaded POD on Load Details Page (Dispatcher View)',
  POD_UPLOADED_DRIVER_VIEW: 'Uploaded POD on Share Load Details Page (Driver View)',
} as const
const QUICKBOOKS_EVENTS = {
  QUICKBOOKS_CONNECT_ACCOUNT_BUTTON_CLICK: 'Clicked Connected Quickbooks Account',
  QUICKBOOKS_IMPORT_CUSTOMERS_BUTTON_CLICK: 'Clicked on import customers button',
  QUICKBOOKS_CREATE_INVOICE_BUTTON_CLICK: 'Clicked Create Invoice button on Load Details modal',
} as const
const RELOAD_EVENTS = {
  LOAD_DETAILS_RELOAD_SEARCH_VIEW: 'Viewed "View Reloads" link on Load Details modal',
  LOAD_DETAILS_RELOAD_SEARCH_CLICK: 'Clicked "View Reloads" link on Load Details modal',
  CLICKED_VIEW_LOAD_FROM_RELOADS_MODAL: 'Clicked View Load From Reloads Modal',
} as const
const CARRIER_MANAGEMENT_EVENTS = {
  CARRIERS_PAGE_VIEWED: 'User Viewed Carriers Page',
  CARRIERS_FINISH_SETUP_CLICKED: 'Clicked "Finish Setup" via Carriers Page',
  CARRIERS_SUBMIT_BUTTON_CLICKED: 'User Added New Carrier via Carriers Page',
  CARRIERS_ADD_ERROR_VIEWED: 'User Viewed Error When Adding Carrier via Carriers Page',
  CARRIERS_JOIN_REQUESTED: 'User Requested to Join Carrier via Carriers Page',
} as const
const TEAM_MANAGEMENT_EVENTS = {
  TEAM_PAGE_VIEWED: 'User Viewed Team Page',
  TEAM_MEMBER_ADD_SUCCESS: 'Added New User via Add Team Member Modal',
  TEAM_MEMBER_ADD_ERROR: 'Viewed Error on Edit Team Member Modal',
  TEAM_MEMBER_EDIT_SUCCESS: 'Edited User Role via Edit Team Member Modal',
  TEAM_MEMBER_EDIT_ERROR: 'Viewed Error on Edit Team Member Modal',
  TEAM_MEMBER_EDIT_MODAL_CHANGED_ROLE: 'Edited Role via Edit Team Member Modal',
  TEAM_MEMBER_EDIT_MODAL_CHANGED_USER_TYPE: 'Edited User Type via Edit Team Member Modal',
  TEAM_MEMBER_EDIT_MODAL_ADDED_CARRIER: 'Added User to Carrier via Edit Team Member Modal',
  TEAM_MEMBER_EDIT_MODAL_REMOVED_CARRIER: 'Removed User from Carrier via Edit Team Member Modal',
} as const
const HOMEPAGE_EVENTS = {
  HOME_PAGE_VIEWED: 'User Viewed Home Page',
  /// // 2023 Q4 HOMEPAGE REDESIGN
  // set up guide
  HOME_SETUP_GUIDE_CLICKED_CTA: 'Clicked setup guide',
  // offers
  HOME_OFFERS_CLICKED_VIEW_ALL: 'Clicked "View All" in offers section of homepage',
  HOME_OFFERS_CLICKED_MOBILE_CARD: 'Clicked offers card on homepage in mobile',
  HOME_OFFERS_CLICKED_FIND_LOADS_BUTTON:
    'Clicked "Find Loads" button in offers empty state on homepage',
  HOME_OFFERS_CLICKED_DEDICATED_LANES_BUTTON:
    'Clicked "Dedicated Lanes" button in offers empty state on homepage',
  // needs attention
  HOME_NEEDS_ATTENTION_CLICKED_CARD: 'Clicked "Loads Need Attention" card on homepage',
  // load summary
  HOME_LOAD_SUMMARY_CLICKED_CARD: 'Clicked "Active Loads" card on homepage',
  HOME_LOAD_SUMMARY_CLICKED_LEARN_LINK: 'Clicked learn link on active loads card',
  HOME_LOAD_SUMMARY_CLICKED_MAP_PIN: 'Clicked on map pin on homepage',
  HOME_LOAD_SUMMARY_CLICKED_MAP_PIN_LINK: 'Clicked on link in map marker on homepage',
  HOME_LOAD_SUMMARY_CLICKED_MY_LOADS_BUTTON:
    'Clicked "My Loads" button in load summary empty state on homepage',
  HOME_LOAD_SUMMARY_CLICKED_FIND_LOADS_BUTTON:
    'Clicked "Find Loads" button in load summary empty state on homepage',
  // popular tools
  HOME_POPULAR_TOOLS_CLICKED_MANAGE_BIDS: 'Clicked "Manage Bids" in popular tools on homepage',
  HOME_POPULAR_TOOLS_CLICKED_FIND_LOADS: 'Clicked "Find Loads" in popular tools on homepage',
  HOME_POPULAR_TOOLS_CLICKED_ADD_SAVED_LANE:
    'Clicked "Add Saved Lane" in popular tools on homepage',
  HOME_POPULAR_TOOLS_CLICKED_CARRIER_PREFERENCES:
    'Clicked "Carrier Preferences" in popular tools on homepage',
  // recommendations
  HOME_RECS_LOADED_MORE: 'Successfully loaded more recs on homepage',
  HOME_RECS_REACHED_END: 'Reached end of recs on homepage',
  HOME_RECS_CLICKED_REC_CARD: 'Clicked on rec card on homepage',
  HOME_RECS_CLICKED_BOOK_LOAD_BUTTON: 'Clicked on "Book Load" on rec card on homepage',
  HOME_RECS_CLICKED_SUBMIT_BID_BUTTON: 'Clicked on "Submit Bid" on rec card on homepage',
} as const
const RESERVED_SHIPMENT_EVENTS = {
  RESERVED_SHIPMENT_DECLINED: 'User declined a reserved shipment',
  RESERVED_SHIPMENT_DECLINED_FAILED: 'API Failed to decline a reserved shipment',
} as const
const SETUP_GUIDE_EVENTS = {
  VIEWED_SETUP_GUIDE: 'Viewed Setup Guide',
  CLICKED_GET_VERIFIED_TO_BOOK_LOADS_FROM_SETUP_GUIDE:
    'Clicked “Get Verified to Book Loads” from Setup Guide',
  CLICKED_CONNECT_ELD_LIVE_TRACKING:
    'Clicked “Connect your ELD for live tracking” from Setup Guide',
  VIEWED_GET_SET_UP_TO_BOOK_LOADS_MODAL: 'Viewed “Get Set Up to Book loads” Modal',
  CLICKED_ON_CARRIER_FROM_GET_SET_UP_TO_BOOK_LOADS_MODAL:
    'Clicked on Carrier from “Get Set Up to Book Loads” Modal',
  CLICKED_ADD_YOUR_FIRST_LOAD_FROM_SETUP_GUIDE: 'Clicked “Add Your First Load” from Setup Guide',
  CLICKED_INVITE_YOUR_DRIVERS_AND_DISPATCHERS_FROM_SETUP_GUIDE:
    'Clicked “Invite Your Drivers and Dispatchers” from Setup Guide',
  VIEWED_COMPLETED_SETUP_GUIDE: 'Viewed Completed Setup Guide',
  VIEWED_ERROR_IN_SETUP_GUIDE: 'Viewed Error In Setup Guide',
  DISMISSED_COMPLETED_SETUP_GUIDE: 'Dismissed Completed Setup Guide',
  VIEWED_BCA: 'Viewed “Sign Broker-Carrier Agreement” (BCA) Step of Activation Flow',
  MISSING_HIGHWAY_DATA: 'Highway data either missing or incomplete, manual form rendered',
  SUBMIT_BCA_SUCCESS: 'Successfully Submitted “Sign Broker-Carrier Agreement” (BCA) Form',
  SUBMIT_BCA_FAILURE: 'Failed to Submit “Sign Broker-Carrier Agreement” (BCA) Form',
  VIEW_UPLOAD_DOCUMENTS: 'Viewed “Upload Documents” Step of Activation Flow',
  UPLOAD_DOCUMENTS_SUCCESS: 'Successfully Submitted “Upload Documents” Form',
  UPLOAD_DOCUMENTS_FAILURE: 'Failed to Submit “Upload Documents” Form',
  UPLOAD_INSURANCE_FAILURE: 'Failed to Submit “Provide Insurance Information” Form',
  SKIPPED_UPLOAD_DOCUMENTS: 'Clicked “Skip and Send Later” on “Upload Documents” Form',
  SKIPPED_SUBMIT_SAFETY_LETTER: 'Clicked “Skip and Send Later” on Provide Safety Letter” Form',
  PROVIDE_SAFETY_LETTER_SUCCESS: 'Successully Submitted "Provide Safety Letter” Form',
  PROVIDE_SAFETY_LETTER_FAILURE: 'Failed to Submit "Provide Safety Letter” Form',
  VIEWED_REFERENCES: 'Viewed “Provide References” Step of Activation Flow',
  SUBMIT_REFERENCES_SUCCESS: 'Successfully Submitted “Provide References” Form',
  SUBMIT_REFERENCES_FAILURE: 'Failed to Submit “Provide References” Form',
  USER_UPLOAD_LARGE_W9_FILE: 'User tried to upload W9 file(s) larger than 10MB',
  USER_UPLOAD_INCOMPATIBLE_W9_FILE: 'User tried to upload W9 file(s) with incompatible types',
  USER_UPLOAD_INCOMPATIBLE_INSURANCE_FILE:
    'User tried to upload insurance file(s) with incompatible types',
} as const
const DEDICATED_LANES_EVENTS = {
  VIEWED_DEDICATED_LANES: 'Viewed Dedicated Lanes',
  VIEWED_DEDICATED_LANE_DETAILS: 'Viewed Dedicated Lane Details',
  SUBMITTED_DEDICATED_LANE_BID: 'Submitted bid on dedicated lane',
  SUBMITTED_REQUEST_FOR_INFO_ON_DEDICATED_LANE: 'Submitted request for info on dedicated lane',
  CLICKED_CONTACT_US_BUTTON: 'Clicked contact us button',
  SUBMITTED_CONTACT_US_MODAL: 'Submitted contact us modal',
} as const
const ENABLE_TRACKING_EVENTS = {
  CLICKED_ENABLE_LIVE_TRACKING: 'Clicked Enable Live Tracking button',
  ENABLE_LIVE_TRACKING_ERROR: 'Error: Enable live tracking',
} as const
const ELD_EVENTS = {
  CLICKED_CONNECT_ELD_BUTTON: 'Clicked Connect ELD Button',
  CLICKED_CONTINUE_ELD_PROVIDER_BUTTON: 'Clicked Continue ELD Provider Button',
  CLICKED_FINALIZE_IMPORT_BUTTON: 'Clicked Finalize Import Button',
  IMPORT_TRUCKS_SUCCESS: 'Import trucks success',
  IMPORT_TRUCKS_FAILED: 'Import trucks failed',
  VIEWED_FLEET_VIEW_SINGLE_TRUCK_PAGE: 'Viewed Fleet View Single Truck Page',
  FOCUSED_INPUT_FLEET_VIEW_FILTERS: 'Focused on Fleet View Filter',
  KT_AUTH_CALLBACK_SUCCESS: 'KeepTruckin authorization successful',
  KT_AUTH_CALLBACK_FAILED: 'KeepTruckin authorization failed',
  KEEPTRUCKIN_AUTH_SUCCESS: 'Successfully authorized KeepTruckin',
  SELECTED_MOBILE_APP_TRACKING_METHOD_ON_RATE_CON:
    'Selected Mobile App as Tracking Method on Rate Con',
  SELECTED_ELD_TRACKING_METHOD_ON_RATE_CON: 'Selected ELD as Tracking Method on Rate Con',
  SELECTED_P44_TRACKING_METHOD_ON_RATE_CON: 'Selected Project44 as Tracking Method on Rate Con',
  SELECTED_KEEP_TRUCKIN_TRACKING_METHOD_ON_RATE_CON:
    'Selected KeepTruckin as Tracking Method on Rate Con',
  CLICKED_CONNECT_KEEP_TRUCKIN_CTA: 'Clicked Connect With KeepTruckin Button on Rate Con Page',
  CLICKED_CONNECT_P44_CTA: 'Clicked Connect With Project44 Button on Rate Con Page',
  CLICKED_CHANGE_TRACKING_METHOD_ON_LOAD_DETAILS_MODAL:
    'Clicked Change Tracking Method on Load Details Modal',
  CLICKED_CHANGE_TRACKING_METHOD_ON_LOAD_DETAILS_PAGE:
    'Clicked Change Tracking Method on Load Details Page',
  SUCCESSFULLY_CHANGED_TRACKING_METHOD: 'Successfully Changed Tracking Method',
  VIEWED_TRUCK_NOT_FOUND_ERROR: 'Viewed Error Message: Truck Number Not Entered',
  VIEWED_MOBILE_NOT_TRACKING_ERROR: 'Viewed Error Message: Not Tracking via Mobile App',
  VIEWED_NOT_CONNECTED_TO_KEEP_TRUCKING_ERROR: 'Viewed Error Message: Not Connected to KeepTruckin',
  VIEWED_TRUCK_NOT_FOUND_IN_KEEP_TRUCKING_ERROR:
    'Viewed Error Message: Truck Not Found in KeepTruckin',
  VIEWED_KEEP_TRUCKING_TRACKING_STOPPED_ERROR: 'Viewed Error Message: KeepTruckin Tracking Stopped',
  VIEWED_NOT_CONNECTED_TO_P44_ERROR: 'Viewed Error Message: Not Connected to Project44',
  VIEWED_TRUCK_NOT_FOUND_IN_P44_ERROR: 'Viewed Error Message: Truck Not Found in Project44',
  VIEWED_P44_TRACKING_STOPPED_ERROR: 'Viewed Error Message: Project44 Tracking Stopped',
} as const
const LANE_ALERTS_EVENTS = {
  CLICKED_GET_LANE_ALERTS_TOGGLE: 'Clicked “Subscribe to Lane Alerts” from Search Results',
  CREATED_LANE_ALERT: 'Successfully Created Lane Alert',
  VIEWED_LANE_ALERTS: 'Viewed Lane Alert with Matches from Book Loads Landing Page',
  CLICKED_LANE_ALERT: 'Clicked on Lane Alert with Matches from Book Loads Landing Page',
  DELETED_LANE_ALERT: 'Deleted Lane Alert from Book Loads Landing Page',
  UNSUBSCRIBED_LANE_ALERT: 'Clicked “Unsubscribe from Lane Alerts” from Search Results',
  VIEWED_AVAILABLE_LOAD_FROM_EMAIL: 'Viewed Available Load from Lane Alert Email',
  VIEWED_UNAVAILABLE_LOAD_FROM_EMAIL: 'Viewed Unavailable Load from Lane Alert Email',
  VIEWED_RUN_IT_AGAIN_PAGE_FROM_EMAIL: 'Viewed Run It Again Page from Lane Alert Email',
  VIEWED_TRANSFIX_ADDED_LANES_PAGE_FROM_EMAIL: 'Viewed Transfix Lanes Page from Lane Alert Email',
  VIEWED_BOOKING_PAGE_FROM_EMAIL: 'Viewed Booking Page from Lane Alert Email',
  CLICKED_DISPATCHER_LANE_ON_TRANSFIX_LANES_PAGE: 'Clicked dispatcher lane on Transfix Lanes page',
  CLICKED_CM_LANE_ON_TRANSFIX_LANES_PAGE: 'Clicked CM lane on Transfix Lanes page',
} as const
const SAVED_LANES_EVENTS = {
  TURNED_ON_SAVED_LANE_NOTIFICATIONS: 'Turned on Saved Lane Notifications',
  TURNED_OFF_SAVED_LANE_NOTIFICATIONS: 'Turned off Saved Lane Notifications',
  CLICKED_SAVED_LANE_CARD: 'Clicked on Saved Lane from Book Loads Landing Page',
  CLICKED_SAVED_LANE_ROW: 'Clicked on Saved Lane from Saved Lanes page',
  CREATED_SAVED_LANE: 'Successfully Created Saved Lane',
  ERROR_CREATING_SAVED_LANE: 'Error creating saved lane',
  UPDATED_SAVED_LANE: 'Successfully Updated Saved Lane',
  ERROR_UPDATING_SAVED_LANE: 'Error updating saved lane',
  DELETED_SAVED_LANE: 'Deleted Saved Lane',
} as const
const LOADS_FOR_YOU_EVENTS = {
  LOADED_MORE_INTELLIGENT_RECS: 'Successfully loaded more intelligent recs',
  END_OF_INTELLIGENT_RECS: 'Reached end of intelligent recs',
  VIEWED_INTELLIGENT_REC_CARD: 'Viewed Intelligent Rec card',
  CLICKED_INTELLIGENT_REC_CARD: 'Clicked on Intelligent Rec card',
  CLICKED_INTELLIGENT_REC_BOOK_LOAD_BUTTON: 'Clicked on "Book Load" on Intelligent Rec card',
  CLICKED_INTELLIGENT_REC_SUBMIT_BID_BUTTON: 'Clicked on "Submit Bid" on Intelligent Rec card',
  ERROR_SENDING_SNOWFLAKE_CLICK: 'Error sending snowflake click event',
  ERROR_SENDING_SNOWFLAKE_VIEW: 'Error sending snowflake view event',
  APOLLO_ERROR_OCCURRED: 'Apollo error occurred while sending snowflake event',
  LOADED_MORE_HISTORICAL_RECS: 'Successfully loaded more historical recs',
  END_OF_HISTORICAL_RECS: 'Reached end of historical recs',
  VIEWED_HISTORICAL_REC_CARD: 'Viewed Historical Rec card',
  CLICKED_HISTORICAL_REC_CARD: 'Clicked on Historical Rec card',
  CLICKED_HISTORICAL_REC_BOOK_LOAD_BUTTON: 'Clicked on "Book Load" on Historical Rec card',
  CLICKED_HISTORICAL_REC_SUBMIT_BID_BUTTON: 'Clicked on "Submit Bid" on Historical Rec card',
}
const SAVED_SEARCHES_EVENTS = {
  CLICKED_TRANSFIX_ADDED_LANES_MODULE:
    'Clicked on “Transfix Added Lanes” Module on Book Loads Page',
} as const
const HISTORICAL_LANES_EVENTS = {
  VIEWED_LOAD_ON_RUN_IT_AGAIN_PAGE: 'Viewed load on Run It Again Page',
  CLICKED_SEE_ALL_LOADS_ON_RUN_IT_AGAIN_PAGE: 'Clicked on “See All Loads” on Run It Again Page',
  CLICKED_HOVER_BID_BUTTON: 'Clicked Bid on Run It Again tile',
  CLICKED_HOVER_BOOK_BUTTON: 'Clicked Book on Run It Again tile',
} as const
const TRUCK_AVAILABILITY_EVENTS = {
  CLICKED_VIEW_TRUCK_AVAILABILITY_IN_BOOK_PAGE: 'Clicked View Truck Availability in Book page',
  CLICKED_TRUCK_AVAILABILITY_POST_IN_BOOK_PAGE: 'Clicked Truck Availability Post in Book page',
  CLICKED_POST_TRUCK_CTA_IN_BOOK_PAGE: 'Clicked Post Truck CTA in Book page',
  CLICKED_POST_TRUCK_CTA_IN_TRUCK_AVAILABILITY_PAGE:
    'Clicked Post Truck CTA in Truck Availability page',
  CLICKED_POST_TRUCK_CTA_IN_HOME_PAGE: 'Clicked Post Truck CTA in Home page',
  CLICKED_POST_TRUCK_IN_POST_RATE_CON_MODAL: 'Clicked Post Truck in post rate con modal',
  SUBMITTED_TRUCK_AVAILABILITY_IN_POST_TRUCK_AVAILABILITY_MODAL:
    'Submitted truck availability in Post Truck Availability modal',
  VIEWED_TRUCK_AVAILABILITY_PAGE_FROM_EMAIL: 'Viewed Truck Availability Page from Lane Alert Email',
  VIEWED_SHARED_TRUCK_AVAILABILITY_PAGE: 'Viewed Shared Truck Availability Page',
  CLICKED_COPY_SHARED_TRUCK_AVAILABILITY_URL_BUTTON:
    'Clicked copy Shared Truck Availability url button',
  POSTED_TRUCK_AVAILABILITY_FROM_RELOADS_MODAL: 'Posted Truck Availability From Reloads Modal',
  NOT_PRESENTED_WITH_RELOADS: 'Not present with reloads',
}
const DEDICATED_LANES_PAGE_EVENTS = {
  VIEWED_DEDICATED_LANES_PAGE: 'Viewed Dedicated Lanes page',
  VIEWED_DEDICATED_LANES_DETAILS_MODAL: 'View Dedicated Lanes details modal',
}
const DETENTION_REVIEW_EVENTS = {
  SUBMITTED_DETENTION_FORM: 'Submitted Detention Form',
}
const DASHBOARD_HOME_PAGE = {
  CLICKED_POST_FIND_LOAD_CTA_IN_HOME_PAGE: 'Clicked Post Find a load to book  CTA in Home page',
  CLICKED_POST_MANAGE_LOADS_CTA_IN_HOME_PAGE: 'Clicked Post Manage my loads CTA in Home page',
  CLICKED_POST_CREATE_LANE_ALERT_CTA_IN_HOME_PAGE:
    'Clicked Post Create a lane alert CTA in Home page',
}
const GUIDED_BIDDING_EVENTS = {
  GUIDED_BID_MESSAGE_SHOWN: 'Guided bidding message shown to user',
}
const MISSING_ATTRIBUTION_SOURCE_EVENTS = {
  SUBMITTED_RATE_CON_WITH_MISSING_ATTRIBUTION_SOURCE:
    'Submitted Rate Con With Missing Attribution Source',
  SUBMITTED_BID_WITH_MISSING_ATTRIBUTION_SOURCE: 'Submitted Bid With Missing Attribution Source',
}
const OFFER_EVENTS = {
  CLICKED_BOOK_NOW_IN_HOME_PAGE: 'Clicked Book Now In Home Page',
  CLICKED_OFFER_ROW_IN_HOME_PAGE: 'Clicked Offer Row In Home Page',
  CLICKED_BOOK_NOW_IN_OFFER_PAGE: 'Clicked Book Now In Offer Page',
  CLICKED_OFFER_ROW_IN_OFFER_PAGE: 'Clicked Offer Row In Offer Page',
  VIEWED_RATE_CONFIRMATION_AND_RE_OFFERED: 'Viewed Rate Confirmation And Re-Offered',
  CLICKED_DECLINE_IN_HOME_PAGE: 'Clicked Decline In Home Page',
  CLICKED_DECLINE_IN_OFFER_PAGE: 'Clicked Decline In Offer Page',
  CLICKED_DECLINE_IN_LOAD_DETAILS: 'Clicked Decline In Load Details',
  /// // 2023 Q4 OFFERS REDESIGN
  SUCCESSFULLY_DECLINED_OFFER: 'Successfully declined offer',
  FAILED_TO_DECLINE_OFFER: 'Failed to decline offer',
  SUCCESSFULLY_REOFFERED: 'Re-offer successful',
  FAILED_TO_REOFFER: 'Failed to re-offer shipment',
  CLICKED_OFFER_ROW_HOMEPAGE: 'Clicked offer on homepage',
  CLICKED_OFFER_ROW_OFFERS_PAGE: 'Clicked offer on offers page',
  CLICKED_DECLINE_OFFER_BUTTON_HOMEPAGE: 'Clicked "Decline" offer on homepage',
  CLICKED_DECLINE_OFFER_BUTTON_OFFERS_PAGE: 'Clicked "Decline" offer on offers page',
  CLICKED_ACCEPT_OFFER_BUTTON_HOMEPAGE: 'Clicked "Accept" offer on homepage',
  CLICKED_ACCEPT_OFFER_BUTTON_OFFERS_PAGE: 'Clicked "Accept" offer on offers page',
}

const LOADS_NEEDING_ATTENTION_EVENTS = {
  FILTERED_LOADS_NEEDING_ATTENTION: 'Filtered loads needing attention',
  CLICKED_LOAD_NEEDING_ATTENTION_ROW: 'Clicked load needing attention row',
}

const MARKET_INSIGHT_EVENTS = {
  FCFS_WINDOW_LABEL_SHOWN_ON_SHIPMENT_DETAILS:
    'Open window (FCFS) label shown to user on shipment modal',
  FCFS_WINDOW_LABEL_SHOWN_ON_BOOK_LOADS_SEARCH_RESULTS:
    'Open window (FCFS) label shown to user on search results',
  POPULAR_WINDOW_LABEL_SHOWN_ON_SHIPMENT_DETAILS: 'Popular label shown to user on shipment modal',
  POPULAR_WINDOW_LABEL_SHOWN_ON_BOOK_LOADS_SEARCH_RESULTS:
    'Popular label shown to user on search results',
  GREAT_WINDOW_LABEL_SHOWN_ON_SHIPMENT_DETAILS: 'Great Rate label shown to user on shipment modal',
  GREAT_WINDOW_LABEL_SHOWN_ON_BOOK_LOADS_SEARCH_RESULTS:
    'Great Rate label shown to user on search results',
}

const CARRIER_SCORECARD_PAGE_EVENTS = {
  VIEWED_CARRIER_SCORECARD_PAGE: 'Viewed Carrier Scorecard page',
  RATE_ON_TIME_RATE: 'Opened time rate modal',
  RATE_TRACKING_QUALITY: 'Opened tracking quality modal',
  RATE_LATE_CANCELLATION: 'Opened late cancellation modal',
}

const ONE_TIME_LOCATION_EVENTS = {
  CLICKED_SUBMIT_ONE_TIME_LOCATION_BUTTON: 'Clicked submit one time location button',
  FAILED_TO_COLLECT_EXPLICIT_LOCATION:
    'Clicking submit one time location button was unsuccessful on the client end',
  FAILED_TO_PROCESS_EXPLICIT_LOCATION:
    'Clicking submit one time location button was unsuccessful on the server end',
}

const FRAUD_EVENTS = {
  DRIVER_VALIDATION_UNAUTHORIZED: 'Driver opened an expired fraud validation link',
  DRIVER_VALIDATION_ERROR: 'Driver opened a fraud validation link but the page load errored',
  DRIVER_VALIDATION_SUCCESS: 'Driver opened a fraud validation link and was able to view the page',

  QR_CODE_GENERATION_SUCCESS: 'Driver generated a QR code for the shipper to scan',
  QR_CODE_GENERATION_ERROR: 'Driver tried to generate a QR code but received an error',

  DRIVER_VERIFICATION_UNAUTHORIZED: 'Facility guard scanned an expired code.',
  DRIVER_VERIFICATION_ERROR: 'Facility guard received an unexpected error',
  DRIVER_VERIFICATION_SUCCESS: 'Facility guard landed on the driver verified page',
}

export const FP_ANALYTICS_EVENTS = {
  Login: { ...LOGIN_EVENTS },
  Onboarding: { ...ONBOARDING_EVENTS },
  Fleet: { ...FLEET_EVENTS },
  'Load List': { ...LOAD_LIST_EVENTS },
  Load: { ...LOAD_EVENTS },
  'Carrier Profile': { ...CARRIER_PROFILE_EVENTS },
  Settings: { ...SETTINGS_EVENTS },
  Support: { ...SUPPORT_MODAL_EVENTS },
  'Marketplace Load': { ...MARKETPLACE_LOAD_EVENTS },
  'Driver Management': { ...MANAGE_DRIVER_EVENTS },
  'Bulk Upload': { ...BULK_UPLOAD_EVENTS },
  'Book Load': { ...BOOK_LOAD_EVENTS },
  'Bids Page': { ...BIDS_PAGE_EVENTS },
  'Bid Accepted Modal': { ...BID_ACCEPTED_MODAL_EVENTS },
  'Bid Countered Modal': { ...BID_COUNTERED_MODAL_EVENTS },
  'Rate Con': { ...RATE_CON_EVENTS },
  'Driver Led Status': { ...DRIVER_LED_STATUS_EVENTS },
  'POD Upload': { ...POD_UPLOAD_EVENTS },
  Quickbooks: { ...QUICKBOOKS_EVENTS },
  Reload: { ...RELOAD_EVENTS },
  'Carrier Management': { ...CARRIER_MANAGEMENT_EVENTS },
  'Team Management': { ...TEAM_MANAGEMENT_EVENTS },
  Homepage: { ...HOMEPAGE_EVENTS },
  'Reserved Load': { ...RESERVED_SHIPMENT_EVENTS },
  'Setup Guide': { ...SETUP_GUIDE_EVENTS },
  'Dedicated Lanes': { ...DEDICATED_LANES_EVENTS },
  Tracking: { ...ENABLE_TRACKING_EVENTS },
  ELD: { ...ELD_EVENTS },
  'Lane Alerts': { ...LANE_ALERTS_EVENTS },
  'Saved Lanes': { ...SAVED_LANES_EVENTS },
  'Loads for You': { ...LOADS_FOR_YOU_EVENTS },
  'Saved Searched': { ...SAVED_SEARCHES_EVENTS },
  'Historical Lanes': { ...HISTORICAL_LANES_EVENTS },
  'Truck Availability': { ...TRUCK_AVAILABILITY_EVENTS },
  'Dedicated Lanes Page': { ...DEDICATED_LANES_PAGE_EVENTS },
  'Detention Review': { ...DETENTION_REVIEW_EVENTS },
  'Find a load to book': { ...DASHBOARD_HOME_PAGE },
  'Create a lane alert': { ...DASHBOARD_HOME_PAGE },
  'Manage my loads': { ...DASHBOARD_HOME_PAGE },
  'Guided Bidding': { ...GUIDED_BIDDING_EVENTS },
  'Missing Attribution Source': { ...MISSING_ATTRIBUTION_SOURCE_EVENTS },
  'Market Load Insights': { ...MARKET_INSIGHT_EVENTS },
  'Carrier Scorecard Page': { ...CARRIER_SCORECARD_PAGE_EVENTS },
  'One Time Locations': { ...ONE_TIME_LOCATION_EVENTS },
  Offers: { ...OFFER_EVENTS },
  'Loads Needing Attention': { ...LOADS_NEEDING_ATTENTION_EVENTS },
  Fraud: { ...FRAUD_EVENTS },
}
